import { createSlice } from '@reduxjs/toolkit'
import { Theme } from '@repo/shared-types'

const initialState: {
  theme: Theme | null
} = {
  theme: null,
}

export const { actions: appearanceActions, reducer: appearanceReducer } = createSlice({
  name: '@app/appearance',
  initialState,
  reducers: {
    themeChanged: (state, { payload }: { payload: Theme }) => {
      state.theme = payload
    },
  },
})
